/**
 * Телефон или нет. Граница — 768 px: ниже неё таблица из тринадцати колонок
 * бессмысленна, и экран брендов показывает список карточек.
 *
 * Слушаем matchMedia, а не resize: он срабатывает только на переходе через
 * границу, а не на каждый пиксель при повороте устройства.
 */
import { useEffect, useState } from 'react'

export const MOBILE_QUERY = '(max-width: 767px)'

function read(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(MOBILE_QUERY).matches
}

export function useIsMobile(): boolean {
  const [mobile, setMobile] = useState(read)

  useEffect(() => {
    const media = window.matchMedia(MOBILE_QUERY)
    const onChange = (event: MediaQueryListEvent) => setMobile(event.matches)
    media.addEventListener('change', onChange)
    setMobile(media.matches)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return mobile
}
